import React from "react";
import { Link } from "react-router-dom";
import "./Growth.css";
import Layout from "../layout/layout";
import mr from "../../images/mr.png";
import mm2 from "../../images/mm2.png";
import jf from "../../images/jf.png";
import rg from "../../images/rg.png";

function Growth() {
  return (
    <Layout>
      <div className="leadership-container">
        <div className="leadership-hero"></div>{" "}
        <h1 id="leadership-head">The Leadership Behind Reszko Nation</h1>
        <div className="leadership-content-container">
          <div className="leadership-content-container-title"></div>{" "}
          <div className="leadership-national">
            <div
              id="leader-container"
              className="leadership-content-container-mr"
            >
              <img className="leader-pic-mr" src={mr}></img>
              <div className="leader-info">
                <h1>Matthew Reszko</h1>
                <h2 className="leader-title">National Director</h2>
                <p className="leader-bio">
                  Matthew Reszko is the founder of Reszko Nation, a multi-region
                  insurance brokerage built on structure, leadership, and
                  scalable growth. He has led expansion across Downtown St.
                  Petersburg, East Tampa, and Fort Lauderdale — developing
                  disciplined teams and future region leaders.<br></br>{" "}
                  <br></br>
                  <b>His philosophy:</b>
                  <br></br>{" "}
                  <i>
                    Standards create freedom. <br></br>
                    Systems create scale. <br></br>Leadership creates legacy.
                  </i>{" "}
                  <br></br>
                  <br></br>Matthew doesn’t build producers —{" "}
                  <b>he builds builders</b>.
                </p>
              </div>
            </div>
          </div>
          <hr className="leadership-divider"></hr>
          <div className="leadership-regional">
            <div
              id="leader-container"
              className="leadership-content-container-rg"
            >
              <img className="leader-pic-mr" src={rg}></img>
              <div className="leader-info">
                <h1>Randy Groesbeck</h1>
                <h2 className="leader-title">
                  Regional Director <br></br> Tampa
                </h2>
                <p className="leader-bio">
                  {" "}
                  Randy Groesbeck is a Regional Sales Director committed to
                  developing high-performing agents/leaders. With a proven track
                  record in both personal production and agent conversion, Randy
                  leads from the front; demonstrating the discipline,
                  consistency, and skill required to succeed in the health/life
                  insurance industry.<br></br>
                  <br></br> His leadership philosophy centers on equipping
                  agents with the product knowledge, sales acumen, and strategic
                  mindset necessary to win. Through hands-on mentorship,
                  structured training, and accountability-driven systems, he
                  empowers agents to maximize their potential and build
                  sustainable, long-term careers.
                </p>
              </div>
            </div>
          </div>
          <hr className="leadership-divider"></hr>
          <div className="leadership-regional">
            <div
              id="leader-container"
              className="leadership-content-container-rg"
            >
              <img className="leader-pic-mr" src={mm2}></img>
              <div className="leader-info">
                <h1>Mariah Menendez</h1>
                <h3 className="leader-title">
                  Divisional Director <br></br> St. Pete
                </h3>
                <p className="leader-bio">
                  I started in the insurance industry as a brand-new agent,
                  simply looking for an opportunity to grow and create a better
                  future. What I found was a career that completely changed my
                  life. Over time, I was able to build a successful business,
                  grow a team, and step into a leadership role that I truly
                  love.<br></br>
                  <br></br>Today, I lead and mentor agents out of my St.
                  Petersburg office while continuing to help clients find
                  coverage that fits their needs and goals. Watching both my
                  clients and my team succeed has been one of the most rewarding
                  parts of this journey. It’s been an incredible experience, and
                  honestly, I wouldn’t change a thing!
                </p>
              </div>
            </div>
          </div>
          <hr className="leadership-divider"></hr>
          <div className="leadership-regional">
            <div
              id="leader-container"
              className="leadership-content-container-rg"
            >
              <img className="leader-pic-mr" src={jf}></img>
              <div className="leader-info">
                <h1>Jerickson Fedrick</h1>
                <h3 className="leader-title">
                  Divisional Director <br></br> Ft. Launderdale
                </h3>
                <p className="leader-bio">
                  Jeri is a Boston, MA native who took football from youth
                  leagues to the D1 level. Moved to Tampa in 2020 to elevate the
                  next chapter. Built on discipline, driven by resilience, and
                  committed to fitness and a powerful mindset.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Growth;
